import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M11.25 14.25q-.618 0-1.059-.44a1.45 1.45 0 0 1-.441-1.06v-7.5q0-.619.441-1.059t1.059-.441h1.5q.619 0 1.06.441.44.441.44 1.059v7.5q0 .619-.44 1.06a1.44 1.44 0 0 1-1.06.44zm-6 0q-.619 0-1.059-.44a1.45 1.45 0 0 1-.441-1.06v-7.5q0-.619.441-1.059T5.25 3.75h1.5q.619 0 1.06.441.44.441.44 1.059v7.5q0 .619-.44 1.06a1.44 1.44 0 0 1-1.06.44zm6-1.5h1.5v-7.5h-1.5zm-6 0h1.5v-7.5h-1.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }